import {ACTIONS} from 'utils/constants';

export const setRemoteConfig = payload => ({
	type: ACTIONS.SET_REMOTE_CONFIG,
	payload,
});
